export default function SponsorsSection() {
  const mainSponsors = [
    { name: 'TechCorp', logo: 'https://readdy.ai/api/search-image?query=modern%20technology%20company%20logo%20white%20on%20transparent%20minimalist%20corporate%20brand%20tech%20industry%20simple%20clean%20design&width=200&height=80&seq=sponsor-1&orientation=landscape' },
    { name: 'AutoMotive Inc', logo: 'https://readdy.ai/api/search-image?query=automotive%20company%20logo%20white%20on%20transparent%20minimalist%20car%20industry%20brand%20simple%20clean%20design&width=200&height=80&seq=sponsor-2&orientation=landscape' },
    { name: 'Engineering Solutions', logo: 'https://readdy.ai/api/search-image?query=engineering%20company%20logo%20white%20on%20transparent%20minimalist%20industrial%20brand%20simple%20clean%20design&width=200&height=80&seq=sponsor-3&orientation=landscape' }
  ];

  const goldSponsors = [
    { name: 'Carbon Tech', logo: 'https://readdy.ai/api/search-image?query=carbon%20fiber%20company%20logo%20white%20on%20transparent%20minimalist%20materials%20brand%20simple%20clean%20design&width=140&height=60&seq=sponsor-4&orientation=landscape' },
    { name: 'Electric Motors', logo: 'https://readdy.ai/api/search-image?query=electric%20motor%20company%20logo%20white%20on%20transparent%20minimalist%20energy%20brand%20simple%20clean%20design&width=140&height=60&seq=sponsor-5&orientation=landscape' },
    { name: 'Aero Dynamics', logo: 'https://readdy.ai/api/search-image?query=aerodynamics%20company%20logo%20white%20on%20transparent%20minimalist%20aerospace%20brand%20simple%20clean%20design&width=140&height=60&seq=sponsor-6&orientation=landscape' },
    { name: 'Smart Systems', logo: 'https://readdy.ai/api/search-image?query=smart%20systems%20company%20logo%20white%20on%20transparent%20minimalist%20technology%20brand%20simple%20clean%20design&width=140&height=60&seq=sponsor-7&orientation=landscape' },
    { name: 'Performance Parts', logo: 'https://readdy.ai/api/search-image?query=performance%20parts%20company%20logo%20white%20on%20transparent%20minimalist%20automotive%20brand%20simple%20clean%20design&width=140&height=60&seq=sponsor-8&orientation=landscape' }
  ];

  const supporters = [
    'DataAnalytics', 'CloudTech', 'SecureNet', 'FastCharge', 'LightWeight', 'PowerBoost', 'SafetyFirst', 'GreenEnergy'
  ];

  return (
    <section id="sponsorlar" className="relative bg-[#1a1a1a] py-32 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h3 className="text-[#00d9ff] text-sm uppercase tracking-[0.3em] font-semibold mb-4">
            SPONSORLARIMIZ
          </h3>
          <h2 className="text-6xl font-bold mb-6">Başarının Ortakları</h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto leading-relaxed">
            Projelerimizi hayata geçirmemizde bize destek olan değerli sponsorlarımıza 
            ve iş ortaklarımıza teşekkür ederiz.
          </p>
        </div>

        {/* Main Sponsors - Tier 1 */}
        <div className="mb-20">
          <div className="flex flex-wrap items-center justify-center gap-16">
            {mainSponsors.map((sponsor, index) => (
              <div
                key={index}
                className="group cursor-pointer transition-all duration-300 hover:scale-110"
              >
                <div className="relative w-[200px] h-[80px] flex items-center justify-center">
                  <img
                    src={sponsor.logo}
                    alt={sponsor.name}
                    className="max-w-full max-h-full object-contain opacity-90 group-hover:opacity-100 transition-opacity duration-300 filter brightness-0 invert"
                  />
                  <div className="absolute inset-0 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-[0_0_30px_rgba(0,217,255,0.4)]" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Gold Sponsors - Tier 2 */}
        <div className="mb-20">
          <div className="flex flex-wrap items-center justify-center gap-12">
            {goldSponsors.map((sponsor, index) => (
              <div
                key={index}
                className="group cursor-pointer transition-all duration-300 hover:scale-110"
              >
                <div className="relative w-[140px] h-[60px] flex items-center justify-center">
                  <img
                    src={sponsor.logo}
                    alt={sponsor.name}
                    className="max-w-full max-h-full object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300 filter brightness-0 invert"
                  />
                  <div className="absolute inset-0 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-[0_0_20px_rgba(0,217,255,0.3)]" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Supporters - Tier 3 with Marquee */}
        <div className="relative overflow-hidden py-8">
          <div className="flex animate-marquee whitespace-nowrap">
            {[...supporters, ...supporters].map((supporter, index) => (
              <div
                key={index}
                className="inline-flex items-center justify-center mx-8 opacity-50 hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                <span className="text-2xl font-bold text-white tracking-wider">
                  {supporter}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-20">
          <h3 className="text-2xl font-bold mb-6">Sponsor Olmak İster misiniz?</h3>
          <button className="group px-10 py-4 border-2 border-[#00d9ff] text-white rounded-full hover:bg-[#00d9ff] hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer">
            <span className="flex items-center gap-3">
              Bizimle İletişime Geçin
              <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-2" />
            </span>
          </button>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
